import React from 'react';
import { VrrButton, VrrCard } from '../../../../shared_components';
import { TProvider } from './types';
import './Provider.scss';

const Provider: React.FC<TProvider> = ({
  title,
  button,
  icon,
  description,
  name,
  withRemove,
  onClickAction,
  onRemoveAction
}) => {
  return (
    <VrrCard
      className="import-data-modal-provider-card"
      {...(withRemove && {
        cardHeader: (
          <>
            <VrrButton
              className="btn-link import-data-modal-provider-remove"
              onClick={onRemoveAction}
              icon={{
                iconLabel: 'tim-icons icon-simple-remove'
              }}
            />
          </>
        )
      })}
      cardBody={{
        element: (
          <div className="import-data-modal-provider">
            <h4>{title}</h4>
            <p>{description}</p>
          </div>
        )
      }}
      cardFooter={
        <div className="provider-card-footer">
          <VrrButton onClick={onClickAction}>
            <div className="provider-footer-icon">
              <div>{icon}</div>
              <div>{button}</div>
            </div>
          </VrrButton>
          <div className="provider-footer-name">{name}</div>
        </div>
      }
    />
  );
};

export default Provider;
